<div *ngIf="(saleLRO$ | async)?.selected?.id" class="flex items-center">
	<div>
		<app-input-wrapper
			[label]="'Land Registry Office' + (required ? ' *' : '')"
			[testHook]="testHooks.InputWrapper"
			[labelIcon]="AI_ICON"
			[labelToolTip]="
				!!(fieldMappings$ | async)?.propertyDetails?.lro && showAiIcon
					? AI_TOOLTIP
					: ''
			"
			[labelIconClasses]="AI_CLASSES"
		>
			<app-pill
				(click)="clearLRO()"
				[remove]="true"
				[testHook]="testHooks.Pill"
			>
				{{ (saleLRO$ | async)?.selected?.name }} ({{
					(saleLRO$ | async)?.selected?.id
				}})
			</app-pill>
		</app-input-wrapper>
	</div>
</div>

<ng-template #lroTemplate let-item>
	{{ item.name }} (LRO {{ item.id }})
</ng-template>

<app-searchable-dropdown
	*ngIf="!saleLRO?.selected"
	[labelIcon]="AI_ICON"
	[labelToolTip]="
		!!(fieldMappings$ | async)?.propertyDetails?.lro && showAiIcon
			? AI_TOOLTIP
			: ''
	"
	[labelIconClasses]="AI_CLASSES"
	[label]="'Land Registry Office' + (required ? ' *' : '')"
	[items]="sortedLROs"
	[ngModel]="saleLRO?.selected"
	(ngModelChange)="selectLRO($event)"
	[testHook]="testHooks.SelectLroSearchableDropdown"
></app-searchable-dropdown>
